const ConfigHelper = {
  getCountryCode: function () {
    const countryCode = process.env.REACT_APP_COUNTRY_CODE;
    return countryCode;
  },
};
export default ConfigHelper;

export const disableConsoleLogs = () => {
   console.log("env", process.env.NODE_ENV);
  if (process.env.NODE_ENV === ('production' || 'development' || 'test')) {
    console.log = () => {};
  }
};